import { FC } from "react";
import { PaginationProps } from "./types";
import WIconButton from "../wicon-button/WIconButton";
import { faArrowLeft, faArrowRight } from "@fortawesome/pro-regular-svg-icons";

const Pagination: FC<PaginationProps> = ({
  page,
  onPrevPage,
  onNextPage,
  total,
  pageCount,
}) => (
  <div className="flex justify-between w-full my-5">
    {page !== 1 ? (
      <WIconButton type="white" icon={faArrowLeft} onClick={onPrevPage} />
    ) : (
      <div />
    )}

    {total && total > 10 && pageCount && page && pageCount > page ? (
      <WIconButton type="white" icon={faArrowRight} onClick={onNextPage} />
    ) : null}
  </div>
);

export default Pagination;
